module.exports = __webpack_public_path__ + "img/isi-certified-3-400-compressed.29256290.png";